export default {
  ichaApi: {
    type: {
      getFullTree: 'api/icha/type/getFullTree',
      getTypeTree: 'api/icha/type/getTypeTree',
      saveType: 'api/icha/type/saveType',
      updateType: 'api/icha/type/updateType',
      delType: 'api/ichatype/delType'
    },
    material: {
      getMaterialList: 'api/icha/material/getMaterialList',
      saveMaterial: 'api/icha/material/saveMaterial',
      updateMaterial: 'api/icha/material/updateMaterial',
      delMaterial: 'api/icha/material/delMaterial',
      getFile: 'api/icha/material/getFile'
    },
    handle: {
      //处理模块
      getList: 'api/icha/haHandle/getList',
      handle: 'api/icha/haHandle/handle',
      countNo: 'api/icha/haHandle/countNo',
      downloadDoc: 'api/icha/haHandle/downloadDoc',
    },
  }
}
